export default {
      id: "hand-okey-icon-usage",
      viewBox: "0 0 13 18",
      url: "/" + "images/icons.3.109.2.svg#hand-okey-icon-usage",
      toString: function () {
        return this.url;
      }
    }